import { Navigate, useParams } from 'react-router-dom';

import { url } from '../../../core/utils/link.ts';

export const legacyRedirect = (path: string, fixedParams: Record<string, string> = {}) =>
    function LegacyRedirect() {
        const { channelId, recordId, tab } = useParams();
        return <Navigate replace to={url(path, { channelId, recordId, tab, ...fixedParams }, { keepSearch: true })} />;
    };
